import { useHotelInfo } from "@/components/features/_hooks/use-hotel-info";
import { useAccommodationHotelPolicyFormModelContext } from "@/components/features/items/edit/hotel-policy/default/ui/context";

export const useHotelInfoOfHotelPolicy = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { hotelInfo } = viewModel;

	return useHotelInfo({ hotelInfo, onSetViewModel });
};
